import { Option } from 'component/Select/Option'
import { Filters } from 'type/Filters'
import { Product } from 'type/Product'
import { by } from 'util/sort'
import { capitalize } from 'util/string'
import { getCategoryGroupTranslation, getTranslation } from 'util/translations'

export const UNLIMITED = 1e9

function optional<T>(enabled: boolean | undefined, options?: T[]): T[] | undefined {
  return enabled && options && options.length > 1 ? options : undefined
}

export class OptionsStore {
  readonly ready: boolean

  readonly brands: string[] | undefined
  readonly styles: string[] | undefined
  readonly genders: string[] | undefined
  readonly categories: Option[] | undefined
  readonly colors: Option[] | undefined
  readonly tsum_seasons: string[] | undefined
  readonly tsum_categories: Option[] | undefined
  readonly tsum_sizes: string[] | undefined

  readonly price_filter: boolean
  readonly tsum_min_price: number
  readonly tsum_max_price: number

  constructor(ready: boolean, options?: Filters, product?: Product) {
    const {
      brandFilter,
      categoryFilter,
      colorFilter,
      company_id,
      genderFilter,
      priceFilter,
      seasonFilter,
      sizeFilter,
      styleFilter,
    } = product ?? {}
    const tsum = company_id === 'tsum_cs'

    this.ready = ready

    this.brands = optional(brandFilter, options?.brands)
    this.styles = optional(styleFilter, options?.styles)
    this.genders = optional(genderFilter, options?.genders)
    this.categories = optional(categoryFilter && !tsum, options?.categories?.map(category => ({
      value: category,
      label: getTranslation('categories', category),
    }))?.sort(by(o => o.label)))
    this.colors = optional(colorFilter, options?.colors?.map(color => ({
      value: color,
      label: capitalize(getTranslation('colors', color)),
    }))?.sort(by(o => o.label)))
    this.tsum_seasons = optional(seasonFilter && tsum, options?.tsum_seasons)
    this.tsum_categories = optional(categoryFilter && tsum, options?.tsum_categories?.map(({ id, name, group }) => ({
      value: id,
      label: getTranslation('categories', name),
      group: getCategoryGroupTranslation(group),
    }))?.sort(by(o => o.group + ' > ' + o.label)))
    this.tsum_sizes = optional(sizeFilter && tsum, options?.tsum_sizes)

    this.price_filter = tsum && !!priceFilter
    this.tsum_min_price = options?.tsum_min_price ?? 0
    this.tsum_max_price = options?.tsum_max_price ?? UNLIMITED
  }

  get filters(): boolean {
    const {
      brands,
      styles,
      categories,
      colors,
      tsum_seasons,
      tsum_categories,
      tsum_sizes,
      price_filter,
    } = this

    return !!(brands || styles || categories || colors
      || tsum_categories || tsum_seasons || tsum_sizes || price_filter)
  }
}
